import { Logo, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { PageDetailFAQ } from 'components/page_detail'
import { CMSFaq } from 'types'

export const BookDetailFAQ = ({
  title,
  faqs,
  loading = false,
}: {
  title: string
  faqs: CMSFaq[]
  loading: boolean
}) => {
  const { colors } = useTheme()

  if (!loading && !faqs?.length) return null

  return loading ? (
    <Logo
      className={css`
        width: fit-content;
        margin: 0 auto;
      `}
      isIcon
      animate
    />
  ) : (
    <div>
      <Text tag="h2" type="header" sizing="XS" color={colors.uiGraphite}>
        {title}
      </Text>
      <div
        className={css`
          position: relative;
          margin-top: 24px;
        `}
      >
        <PageDetailFAQ faqs={faqs} />
      </div>
    </div>
  )
}
